import components from './components/index.js'
import others from './others/index.js'
import pages from './pages/index.js'

export default {
  components,
  others,
  pages
}
